import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { uploadCCFPointsAPI, uploadMappedCCFAPI } from '../../apiConfig/apiCall';
import { toast } from 'react-toastify';
import SampleCSVFileForCCFUpload from '../../csvFiles/ccf-cvp-mapping-sample.csv'
import Select from "react-select";
import useReactSelectCustomStyle from '../../hooks/useReactSelectCustomStyle';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getCertificationList } from '../../slices/ManageCompliance/manageComplianceSlice';

export default function UploadMappedCCF({ uploadMappedCCFModal, setUploadMappedCCFModal, toggleUploadMappedCCFModal }) {

    const selectBoxCustomStyles = useReactSelectCustomStyle();
    const dispatch = useDispatch();
    const { isLoading, isError, data } = useSelector(state => state.manageCompliance);

    const [csvFile, setCsvFile] = useState(null);
    const [selectedMappingOption, setSelectedMappingOption] = useState(null);
    const [selectedCertificationOption, setSelectedCertificationOption] = useState(null);

    const mappingOptions = [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
    ];

    const certificationOptions = data?.map(item => ({ value: item.certificationType, label: item.certificationType })) || [];

    const handleDownloadSampleFile = () => {
        const link = document.createElement('a');
        link.href = SampleCSVFileForCCFUpload;
        link.download = 'ccf-cvp-mapping-sample.csv';
        link.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type === "text/csv" || file.name.endsWith(".csv")) {
                setCsvFile(file);
            } else {
                setCsvFile(null);
                toast.error("Please upload a valid CSV file.");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!selectedMappingOption) {
            toast.error("Please select a mapping option.");
            return;
        }

        if (!selectedCertificationOption) {
            toast.error("Please select a certification.");
            return;
        }

        if (!csvFile) {
            toast.error("Please upload a valid CSV file.");
            return;
        }

        const formData = {
            clearMapping: selectedMappingOption.value,
            certification: selectedCertificationOption.value,
            file: csvFile
        }

        try {
            const apiResponse = await uploadMappedCCFAPI(formData);
            if (apiResponse.status === 200) {
                toast.success(apiResponse.data);
                setUploadMappedCCFModal(false);
            } else {
                toast.error(apiResponse.data);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            toast.error("An error occurred while uploading the CSV file.");
        }
    };

    useEffect(() => {
        dispatch(getCertificationList());
    }, [dispatch]);

    return (
        <>
            <Modal isOpen={uploadMappedCCFModal} toggle={toggleUploadMappedCCFModal}>
                <ModalHeader toggle={toggleUploadMappedCCFModal}>
                    Upload Mapped CCF
                    <Button
                        color="primary"
                        className="waves-effect waves-light material-shadow-none mx-3"
                        outline
                        onClick={handleDownloadSampleFile}
                    >
                        <i className="ri-download-2-line me-2" />
                        Download Sample File
                    </Button>
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row className="gy-3">
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="status" className="form-label">Clear Mapping</Label>
                                    <Select
                                        options={mappingOptions}
                                        styles={selectBoxCustomStyles}
                                        onChange={(option) => setSelectedMappingOption(option)}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="status" className="form-label">Certification</Label>
                                    <Select
                                        options={certificationOptions}
                                        styles={selectBoxCustomStyles}
                                        onChange={(option) => setSelectedCertificationOption(option)}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <Label htmlFor="csvFile" className="form-label">CSV File</Label>
                                    <Input
                                        type="file"
                                        className="form-control"
                                        id="csvFile"
                                        onChange={handleFileChange}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <Button color="primary" type="submit" className="me-2">Upload CCF</Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}